import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Tabs,
  Tab,
  Grid,
  Box,
  Card,
  IconButton,
  Input,
  InputAdornment,
  Typography,
  Stack,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import AddLanguageDialog from "popup/AddLanguageDialog";
import AddAlarmTypeDialog from "popup/AddAlarmTypeDialog";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { get } from "aws-amplify/api";
import LaunchIcon from "@mui/icons-material/Launch";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridRowModes,
  useGridApiRef,
} from "@mui/x-data-grid";
import { I18n } from "@aws-amplify/core";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import currentUserToken from "CurrentUserToken";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SplitterLayout from "react-splitter-layout";
import SuggestionDialog from "popup/SuggestionDialog";
import { post } from "aws-amplify/api";
import TypeDetails from "./components/TypeDetails";
import { APIStatusDialog } from "components/APIStatusDialog";
import ConfirmDeleteDialog from "popup/ConfirmDeleteDialog";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DataGridPro } from "@mui/x-data-grid-pro/DataGridPro";
import { GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import EncodingSettingsMenu from "./components/EncodingSettingsMenu";
import PatternSettingsMenu from "./components/PatternSettingsMenu";
import { itIT } from "@mui/x-data-grid/locales";
import { deDE } from "@mui/x-data-grid/locales";
import EventHistorySettingsMenu from "./components/EventHistorySettingsMenu";
import { fetchAuthSession } from "@aws-amplify/core";
import { useTemplateController } from "context";
import BrushIcon from "@mui/icons-material/Brush";
import EditColorPopup from "popup/EditColorPopup";
const COLUMN_VISIBILITY_KEY = "columnVisibility_settings";

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};
const reducer2 = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};
function AlarmType() {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedAlarmTypeIdToDelete, setSelectedAlarmTypeIdToDelete] =
    useState(null);
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const route = useLocation().pathname.split("/").slice(1);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [languages, setLanguages] = useState([]);
  const formatLanguageName = (languages) => {
    return languages.charAt(0).toUpperCase() + languages.slice(1).toLowerCase();
  };
  const [tableParentIsMD, setTableParentIsMD] = useState(false);

  const toolbarRef = useRef(null);

  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const apiRef = useGridApiRef();
  const [searchText, setSearchText] = useState("");
  const [resizeThrottle, setResizeThrottle] = useState(60);
  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));
  const [openLanguageDialog, setOpenLanguageDialog] = useState(false);
  const [rowModesModel, setRowModesModel] = useState({});
  const [openAlarmTypeDialog, setOpenAlarmTypeDialog] = useState(false);
  const [showSplitter, setShowSplitter] = useState(false);
  const [filters, setFilters] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null); // Aggiungi uno stato per la riga selezionata
  const [selectedAlarmTypeId, setSelectedAlarmTypeId] = useState(null); // State to store selected alarm_type_id
  const [suggestionDialogOpen, setSuggestionDialogOpen] = useState(false);
  const [state2, dispatch2] = useReducer(reducer2, {
    audit: [],
    fetched: false,
  });
  const [profile, setProfile] = useState("");
  const [groupNameSel, setGroupNameSel] = useState(""); // State to store selected group name
  const [colorDialogOpen, setColorDialogOpen] = useState(false); // State to control color dialog
  const [refreshLanguages, setRefreshLanguages] = useState(() => () => {});
  const isAdmin = profile.includes("Admin");

  const tlmGetUserGroups = async (userID) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/groups",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { user_id: userID },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      setProfile(response.profiles.map((profile) => profile.group_name) || []);
      // Extract profiles from the response and set groupNameSel with the first profile
      const profiles = response.profiles.map((profile) => profile.group_name);

      if (profiles.length > 0) {
        setGroupNameSel(profiles[0]); // Set default selected profile
      }

      dispatch2({ type: "DATA_RECEIVED", value: profiles });
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };
  useEffect(() => {
    async function currentSession() {
      try {
        const { accessToken, idToken } =
          (await fetchAuthSession()).tokens ?? {};
        await tlmGetUserGroups(idToken.payload["cognito:username"]);
      } catch (err) {}
    }
    currentSession();
  }, []);
  const handleCloseSuggestionDialog = () => {
    setSuggestionDialogOpen(false);
  };

  const handleSaveSuggestion = (suggestions) => {};

  const searchChanged = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    const savedColumnVisibility = localStorage.getItem(COLUMN_VISIBILITY_KEY);
    if (savedColumnVisibility) {
      setColumnVisibilityModel(JSON.parse(savedColumnVisibility));
    } else {
      // Set default visibility to only show specified columns
      setColumnVisibilityModel({
        alarm_type_id: false,
      });
    }
  }, []);

  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(COLUMN_VISIBILITY_KEY, JSON.stringify(newModel));
  };

  const applyStoreFiltering = (value) => {
    let matchesAllFilters = true;
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      matchesAllFilters =
        matchesAllFilters &&
        Object.values(value).some((val) =>
          String(val).toLowerCase().includes(searchTextLower)
        );
    }
    return matchesAllFilters;
  };
  const filteredRows = state.audit.filter(applyStoreFiltering);
  const filteredRowsCount = filteredRows.length;
  const handleOpenLanguageDialog = () => {
    setOpenLanguageDialog(true);
  };
  const handleCloseLanguageDialog = () => {
    setOpenLanguageDialog(false);
  };
  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowModes.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleConfirmDelete = async () => {
    setDeleteDialogOpen(false);
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Deleting alarm type"),
      });

      const restOperation = await tlmDeletePI(selectedAlarmTypeIdToDelete);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Alarm type successfully deleted"),
        });
        dispatch({
          type: "DATA_RECEIVED",
          value: state.audit.filter(
            (row) => row.alarm_type_id !== selectedAlarmTypeIdToDelete
          ),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to delete alarm type"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to delete alarm type"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false); // Chiudi il dialogo senza fare nulla
  };

  const processRowUpdate = async (newRow) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Saving modification"),
      });

      const descriptionBody = languageColumns.reduce((acc, column) => {
        acc[column.field] = newRow[column.field] || ""; // Ensure empty descriptions are handled
        return acc;
      }, {});
      const severity = newRow.severity;
      const restOperation = await tlmModifyDescription(
        newRow.alarm_type_id,
        descriptionBody,
        severity
      );
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Modification successfully saved"),
        });
        const updatedRow = state.audit.map((row) =>
          row.alarm_type_id === newRow.alarm_type_id ? newRow : row
        );
        dispatch({ type: "DATA_RECEIVED", value: updatedRow });
        tlmGetAlarmDescription();
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
        }, 2000);
        return newRow;
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to save modification"),
        });
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
        }, 2000);
        return newRow;
      }
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to save modification"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      return newRow;
    }
  };

  const handleOpenAlarmTypeDialog = () => {
    setOpenAlarmTypeDialog(true);
  };
  const handleSaveAlarmType = (alarmType) => {};

  const tlmGetAlarmDescription = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/alarms/description",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };
  useEffect(() => {
    tlmGetAlarmDescription();
  }, []);

  const tlmModifyDescription = async (alarmTypeId, descriptions, severity) => {
    try {
      const response = post({
        apiName: "TelemonitoringAPI",
        path: "/alarms/description/edit",
        options: {
          body: descriptions,
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            alarm_type_id: alarmTypeId,
            alarm_severity: severity,
          },
        },
      });
      return response;
    } catch (error) {}
  };

  const tlmModifyColor = async (alarmTypeId, descriptions, colour) => {
    try {
      const response = post({
        apiName: "TelemonitoringAPI",
        path: "/alarms/description/edit",
        options: {
          body: descriptions,
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            alarm_type_id: alarmTypeId,
            color: colour,
          },
        },
      });
      return response;
    } catch (error) {}
  };

  const tlmDeletePI = async (alarmTypeId) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/alarm/type/remove",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            alarm_type_id: alarmTypeId, // Passa l'ID dell'allarme come query parameter
          },
        },
      });
      return restOperation;
    } catch (error) {
      console.error("Errore durante la chiamata API di eliminazione:", error);
    }
  };

  useEffect(() => {
    const tlmGetLanguagesAPI = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/languages",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {},
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        setLanguages(response);
      } catch (error) {
        console.error("Errore durante la chiamata API:", error);
      }
    };
    tlmGetLanguagesAPI();
  }, []);

  const handleSaveLanguage = async (language) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Saving language"),
      });

      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/languages/add",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            language: language,
          },
        },
      });

      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Language successfully added"),
        });
        setLanguages((prevLanguages) => [...prevLanguages, language]);
        // Update the languages in DashboardNavbar
        setRefreshLanguages((refreshLanguages) => {
          window.refreshLanguages = refreshLanguages;
        });
        // Dynamically trigger refresh after success
        if (window.refreshLanguages) {
          window.refreshLanguages(); // Call the refresh function
        }
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to add language"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to add language"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  const handleEditColorSubmit = async (newRow) => {
    setColorDialogOpen(false);
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Saving modification"),
      });
      const descriptionBody = languageColumns.reduce((acc, column) => {
        acc[column.field] = selectedRow[column.field] || ""; // Ensure empty descriptions are handled
        return acc;
      }, {});

      const restOperation = await tlmModifyColor(
        newRow.alarm_type_id,
        descriptionBody,
        newRow.colour
      );
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Modification successfully saved"),
        });
        tlmGetAlarmDescription();
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
        }, 2000);
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to save modification"),
        });
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
        }, 2000);
      }
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to save modification"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  const languageColumns = useMemo(() => {
    return languages.map((language) => ({
      field: language,
      headerName: I18n.get(formatLanguageName(language)), // Assuming formatLanguageName returns the key for translation
      width: 300,
      editable: true,
    }));
  }, [languages]);
  const isDeleteEnabled = !(
    groupNameSel === "SuperAdmin" || groupNameSel === "Admin"
  ); // Verifica se "SuperAdmin" è nel profilo

  const columns = useMemo(() => {
    const handleEditClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };
    const handleSaveClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
    const handleEditColor = (row) => () => {
      setColorDialogOpen(true);
      setSelectedRow(row);
    };
    const handleDeleteClick = (id) => () => {
      setSelectedAlarmTypeIdToDelete(id); // Memorizza l'ID dell'allarme da eliminare
      setDeleteDialogOpen(true); // Apri il pop-up di conferma
    };
    const handleOpenSplitter = (row) => {
      setSelectedRow(row); // Imposta i dati della riga selezionata
      setShowSplitter(true); // Mostra lo splitter
    };
    const handleOpenSuggestionDialog = (alarmTypeId) => {
      setSelectedAlarmTypeId(alarmTypeId); // Store the selected alarm_type_id
      setSuggestionDialogOpen(true); // Open the SuggestionDialog
    };
    const handleCancelClick = (id) => () => {
      setRowModesModel({
        ...rowModesModel,
        [id]: { mode: GridRowModes.View, ignoreModifications: true },
      });
    };

    return [
      {
        field: "severity",
        headerName: I18n.get("Severity"),
        width: 200,
        editable: true,
      },
      {
        field: "colour",
        headerName: I18n.get("Color"),
        width: 100,
        editable: false,

        renderCell: (params) => (
          <Box
            sx={{
              backgroundColor: params.value,
              height: "100%",
              width: "100%",
            }}
          />
        ),
      },
      ...languageColumns, // Include dynamic language columns
      {
        field: "actions",
        type: "actions",
        headerName: I18n.get("Actions"),
        width: 200,
        cellClassName: "actions",

        getActions: ({ id, row }) => {
          const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
          if (isInEditMode) {
            return [
              <Tooltip title={I18n.get("Save")}>
                <GridActionsCellItem
                  icon={<SaveIcon />}
                  label={I18n.get("Save")}
                  sx={{ color: "primary.main" }}
                  onClick={handleSaveClick(id)}
                />
              </Tooltip>,
              <Tooltip title={I18n.get("Cancel")}>
                <GridActionsCellItem
                  icon={<CancelIcon />}
                  label={I18n.get("Cancel")}
                  onClick={handleCancelClick(id)}
                />
              </Tooltip>,
              <Tooltip title={I18n.get("Open Suggestion")}>
                <IconButton
                  onClick={() => handleOpenSuggestionDialog(id)}
                  color="inherit"
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </Tooltip>,
              <Tooltip title={I18n.get("Open Message")}>
                <IconButton
                  onClick={() => handleOpenSplitter(row)} // Apre lo splitter con i dati della riga
                  color="inherit"
                >
                  <LaunchIcon />
                </IconButton>
              </Tooltip>,
            ];
          }
          return [
            <Tooltip title={I18n.get("Edit")}>
              <GridActionsCellItem
                icon={<EditIcon />}
                label={I18n.get("Edit")}
                onClick={handleEditClick(id)}
              />
            </Tooltip>,
            <Tooltip title={I18n.get("Edit Color")}>
              <GridActionsCellItem
                icon={<BrushIcon />}
                label={I18n.get("Edit")}
                onClick={handleEditColor(row)}
                disabled={isAdmin}
              />
            </Tooltip>,
            <Tooltip title={I18n.get("Delete")}>
              <GridActionsCellItem
                icon={<DeleteIcon />}
                label={I18n.get("Delete")}
                onClick={handleDeleteClick(id)}
                disabled={
                  isAdmin ||
                  isDeleteEnabled ||
                  row.alarm_type_id === 1 ||
                  row.alarm_type_id === 2
                } // Usa profile[0] per confrontare il valore
              />
            </Tooltip>,
            <Tooltip title={I18n.get("Open Suggestion")}>
              <IconButton
                onClick={() => handleOpenSuggestionDialog(id)}
                color="inherit"
              >
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>,
            <Tooltip title={I18n.get("Open Message")}>
              <IconButton
                onClick={() => handleOpenSplitter(row)} // Apre lo splitter con i dati della riga
                color="inherit"
              >
                <LaunchIcon />
              </IconButton>
            </Tooltip>,
          ];
        },
      },
    ];
  }, [languageColumns, rowModesModel, groupNameSel]);

  const renderToolbar = () => {
    return (
      <div ref={toolbarRef}>
        <Stack direction="row" alignItems="center" spacing={2} marginBottom={1}>
          <Typography variant="h5" mt={0.5} mb={1}>
            {I18n.get("Alarm Types")} (
            {filters ? filteredRowsCount : totalCount})
          </Typography>
        </Stack>
        <Stack
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          justifyContent={tableParentIsMD ? "center" : "space-between"}
          spacing={2}
          sx={{ pb: 2 }}
        >
          <Stack
            direction={tableParentIsMD ? "column" : "row"}
            spacing={2}
            sx={{ width: "100%" }}
          >
            <Button
              onClick={handleOpenAlarmTypeDialog}
              color="primary"
              variant="outlined"
              startIcon={<AddIcon />}
              fullWidth={tableParentIsMD}
              disabled={isDeleteEnabled}
            >
              {I18n.get("Add New Alarm Type")}
            </Button>
            <Button
              onClick={handleOpenLanguageDialog}
              color="primary"
              variant="outlined"
              startIcon={<AddIcon />}
              fullWidth={tableParentIsMD}
            >
              {I18n.get("Add New Language")}
            </Button>
          </Stack>
          <Input
            type="text"
            placeholder={I18n.get("Search")}
            onChange={searchChanged}
            fullWidth={tableParentIsMD}
            endAdornment={
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Stack>
      </div>
    );
  };
  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    } else if (userAgent.includes("Chrome")) {
      return "Chrome";
    }
  }
  const browser = getBrowserName();

  const handleRowClick = (params) => {
    const clickedRow = params.row;
    setSelectedRow(clickedRow); // Mantieni la selezione della riga senza aprire lo splitter
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const [tableHeight, setTableHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const margin =
        browser === "Firefox" ? 200 : browser === "Chrome" ? 200 : 200;
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        margin;
      setTableHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);
  const darkMode = localStorage.getItem("darkMode") === "true";
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
          refreshLanguages={refreshLanguages}
        />
        <Stack
          direction="row"
          spacing={1}
          sx={{ ml: 3, mt: 3, width: "400px" }}
        >
          <EncodingSettingsMenu />
          <PatternSettingsMenu />
          <EventHistorySettingsMenu />
        </Stack>
        <SplitterLayout
          vertical={mobileDevice}
          percentage={true}
          primaryIndex={0}
          primaryMinSize={mobileDevice ? 30 : 50}
          secondaryMinSize={35}
          secondaryInitialSize={mobileDevice ? 30 : 50}
          customClassName="splitter-layout-custom"
        >
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
                  {" "}
                  {/** lasciare così */}
                  <Card
                    sx={{
                      p: 3,
                      maxHeight: `${tableHeight}px`,
                      overflow: "auto",
                    }}
                  >
                    {renderToolbar()}
                    {browser === "Firefox" || "Chrome" ? (
                      <Box sx={{ p: 2 }}>
                        <DataGridPro
                          sx={{
                            "& .MuiDataGrid-root, & .MuiDataGrid-footerContainer":
                              {
                                minHeight: "2rem",
                              },
                            "&  .MuiDataGrid-cell ": {
                              cursor: "default",
                            },
                            borderColor: darkMode ? "#6B635A" : "",
                            "& .MuiDataGrid-cell, &.MuiDataGrid-columnHeaders":
                              {
                                borderColor: darkMode ? "#625a52" : "",
                              },
                            "& .MuiDataGrid-columnSeparator": {
                              borderColor: darkMode ? "#625a52" : "",
                            },
                            "--DataGrid-rowBorderColor": darkMode
                              ? "#625a52"
                              : "",
                            minHeight: "20vh",
                            flexFlow: 1,
                            height: "100%",
                          }}
                          hideFooter
                          hideFooterPagination
                          hideFooterRowCount //rimuove total row count
                          localeText={
                            language === "it"
                              ? itIT.components.MuiDataGrid.defaultProps
                                  .localeText
                              : language === "ge"
                              ? deDE.components.MuiDataGrid.defaultProps
                                  .localeText
                              : ""
                          }
                          rows={filteredRows}
                          columns={columns}
                          // pagination
                          autoPageSize
                          initialState={{
                            density: "compact",
                            pinnedColumns: { right: ["actions"] },
                          }}
                          getRowId={(row) => row.alarm_type_id}
                          editMode="row"
                          rowModesModel={rowModesModel}
                          onRowModesModelChange={(newModel) =>
                            setRowModesModel(newModel)
                          }
                          onRowEditStop={handleRowEditStop}
                          processRowUpdate={processRowUpdate}
                          apiRef={apiRef}
                          onRowClick={handleRowClick}
                          onSelectionModelChange={(newSelection) => {
                            const selectedRows = newSelection.map((id) =>
                              filteredRows.find((row) => row.id === id)
                            );
                          }}
                          columnVisibilityModel={columnVisibilityModel}
                          resizeThrottleMs={resizeThrottle}
                          loading={!state.fetched || resizeThrottle > 60}
                          onColumnVisibilityModelChange={
                            handleColumnVisibilityChange
                          }
                          slotProps={{
                            loadingOverlay: {
                              variant: "skeleton",
                              noRowsVariant: "skeleton",
                            },
                          }}
                          slots={{
                            toolbar: () => (
                              <GridToolbarContainer>
                                <GridToolbarColumnsButton />
                                <GridToolbarExport
                                  printOptions={{ disableToolbarButton: true }}
                                  csvOptions={{
                                    fileName: "Alarm Types",
                                    utf8WithBom: true,
                                  }}
                                />
                                <GridToolbarFilterButton />
                              </GridToolbarContainer>
                            ),
                          }}
                        />
                      </Box>
                    ) : (
                      <DataGridPro
                        sx={{
                          minHeight: "20vh",
                          "& .MuiDataGrid-root, & .MuiDataGrid-footerContainer":
                            {
                              minHeight: "2rem",
                            },
                          "& .MuiDataGrid-actionsCell": {
                            gap: 0,
                            height: "100%",
                          },
                          borderColor: darkMode ? "#6B635A" : "",
                          "& .MuiDataGrid-cell, &.MuiDataGrid-columnHeaders": {
                            borderColor: darkMode ? "#625a52" : "",
                          },
                          "& .MuiDataGrid-columnSeparator": {
                            borderColor: darkMode ? "#625a52" : "",
                          },
                          "--DataGrid-rowBorderColor": darkMode
                            ? "#625a52"
                            : "",
                        }}
                        hideFooterPagination
                        hideFooterRowCount //rimuove total row count
                        localeText={
                          language === "it"
                            ? itIT.components.MuiDataGrid.defaultProps
                                .localeText
                            : language === "ge"
                            ? deDE.components.MuiDataGrid.defaultProps
                                .localeText
                            : ""
                        }
                        rows={filteredRows}
                        columns={columns}
                        // pagination
                        autoPageSize
                        initialState={{
                          density: "compact",
                          pinnedColumns: { right: ["actions"] },
                        }}
                        getRowId={(row) => row.alarm_type_id}
                        editMode="row"
                        rowModesModel={rowModesModel}
                        onRowModesModelChange={(newModel) =>
                          setRowModesModel(newModel)
                        }
                        onRowEditStop={handleRowEditStop}
                        processRowUpdate={processRowUpdate}
                        apiRef={apiRef}
                        onRowClick={handleRowClick}
                        onSelectionModelChange={(newSelection) => {
                          const selectedRows = newSelection.map((id) =>
                            filteredRows.find((row) => row.id === id)
                          );
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        resizeThrottleMs={resizeThrottle}
                        loading={!state.fetched || resizeThrottle > 60}
                        onColumnVisibilityModelChange={
                          handleColumnVisibilityChange
                        }
                        slotProps={{
                          loadingOverlay: {
                            variant: "skeleton",
                            noRowsVariant: "skeleton",
                          },
                        }}
                        slots={{
                          toolbar: () => (
                            <GridToolbarContainer>
                              <GridToolbarColumnsButton />
                              <GridToolbarExport
                                printOptions={{ disableToolbarButton: true }}
                                csvOptions={{
                                  fileName: "Alarm Types",
                                  utf8WithBom: true,
                                }}
                              />
                              <GridToolbarFilterButton />
                            </GridToolbarContainer>
                          ),
                        }}
                      />
                    )}
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </div>
          {showSplitter && (
            <TypeDetails
              isOpen={showSplitter}
              onClose={() => setShowSplitter(false)}
              rowData={selectedRow} // Correctly passing the selected row data
            />
          )}
        </SplitterLayout>
      </DashboardLayout>
      <AddLanguageDialog
        open={openLanguageDialog}
        onClose={handleCloseLanguageDialog}
        onSave={handleSaveLanguage}
      />
      <AddAlarmTypeDialog
        open={openAlarmTypeDialog}
        onClose={() => {
          setOpenAlarmTypeDialog(false);
          tlmGetAlarmDescription();
        }}
        onSave={handleSaveAlarmType}
        languages={languages}
      />
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
      {colorDialogOpen && (
        <EditColorPopup
          isOpen={colorDialogOpen}
          onClose={() => setColorDialogOpen(false)}
          mainFormData={selectedRow} // Pass the selected row data to the color dialog
          handleEditColorSubmit={handleEditColorSubmit}
        />
      )}
      {suggestionDialogOpen && (
        <SuggestionDialog
          open={suggestionDialogOpen}
          onClose={handleCloseSuggestionDialog}
          onSave={handleSaveSuggestion}
          alarmTypeId={selectedAlarmTypeId}
        />
      )}
      <ConfirmDeleteDialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
}

export default AlarmType;
